import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import { Element } from 'react-scroll';
import { isNullOrUndefinedOrEmpty } from '../../../../../helpers/common';
import { arraySortFunc } from '../../../../../helpers/common/ArrayHelper';
import { propArrayShape, propFunc, propOneOf, } from '../../../../../helpers/custom-prop-types';
import ProfessionalUnitFilterSelect from '../../Parts/ProfessionalUnitFilterSelect';
import ProfessionalUnitItemsList from '../../Parts/ProfessionalUnitItemsList';
import ProfessionalUnitSectionTitle from '../../Parts/ProfessionalUnitSectionTitle';
import ProfessionalUnitProfessionalWrapper from './ProfessionalUnitProfessionalWrapper';
const ProfessionalUnitProfessionals = (props) => {
    const { professionals: rawProfessionals, showAlertModal, userMode } = props;
    const [filter, changeFilter] = useState('');
    /**
     * 絞り込みの所属部署一覧
     * @type {*}
     */
    const options = useMemo(() => {
        const values = rawProfessionals
            .map((p) => _.get(p, 'department'))
            .filter((v) => !isNullOrUndefinedOrEmpty(v));
        return _.uniq(values).map((v) => ({ id: v, label: v, value: v }));
    }, [rawProfessionals]);
    /**
     * 絞り込み選択時のイベント
     * @type {(function({value?: *}): void)|*}
     */
    const onChangeFilter = useCallback(({ value }) => {
        changeFilter(value);
    }, [changeFilter]);
    /**
     * 絞り込み後のコンサル一覧
     */
    const items = useMemo(() => {
        const sortedProfessionals = rawProfessionals
            .map((p) => (Object.assign(Object.assign({}, p), { position: parseInt(p.position, 10) })))
            .sort((leftValue, rightValue) => 
        // 役職が未登録の場合は後ろに表示
        !leftValue.position
            ? 1
            : arraySortFunc(leftValue, rightValue, 'position'));
        return sortedProfessionals.filter((v) => isNullOrUndefinedOrEmpty(filter) ? true : v.department === filter);
    }, [filter, rawProfessionals]);
    if (!rawProfessionals.length) {
        return null;
    }
    return (_jsxs("section", Object.assign({ className: 'unit_professionals' }, { children: [_jsx(Element, { name: 'section_professionals' }), _jsx(ProfessionalUnitSectionTitle, { count: rawProfessionals.length, title: '登録コンサルタント', unit: '名' }), _jsx(ProfessionalUnitFilterSelect, { name: 'professional_filter', onChange: onChangeFilter, options: options, placeholder: '所属で絞り込む', userMode: userMode }), _jsx(ProfessionalUnitItemsList, { className: 'professional_items', guestMoreText: '所属コンサルタントをすべて見る（会員登録）', items: items, renderComponent: _jsx(ProfessionalUnitProfessionalWrapper, { showAlertModal: showAlertModal, userMode: userMode }), showAlertModal: showAlertModal, userMode: userMode })] })));
};
ProfessionalUnitProfessionals.propTypes = {
    professionals: propArrayShape().isRequired,
    showAlertModal: propFunc().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
export default ProfessionalUnitProfessionals;
